import defaultSettings from '@/settings'
import { getBaseSettingTitle } from '@/api/user'

const title = defaultSettings.title || '胜天半子'

export default function getPageTitle() {
  getBaseSettingTitle({ type: 'SCM' }).then(res => {
    if (res.code == 1) {
      document.title = res.data
      sessionStorage.setItem('saveTitle', res.data)
    }
  })
}
